import { useQuery } from '@tanstack/react-query';
import { getAnonKey, getEdgeFunctionUrl } from '@/utils/supabaseUrl';

interface PublicDepartment {
  id: string;
  name: string;
  code: string;
}

interface PublicCostPosition {
  id: string;
  name: string;
  code: string;
}

export const usePublicDepartments = () => {
  return useQuery({
    queryKey: ['public-departments'],
    queryFn: async () => {
      const response = await fetch(
        `${getEdgeFunctionUrl('public-payment-data')}?type=departments`,
        {
          headers: {
            'apikey': getAnonKey(),
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        throw new Error('Failed to fetch departments');
      }

      const result = await response.json();
      return result.departments as PublicDepartment[];
    },
  });
};

export const usePublicCostPositions = (departmentId: string | null) => {
  return useQuery({
    queryKey: ['public-cost-positions', departmentId],
    queryFn: async () => {
      if (!departmentId) return [];

      const response = await fetch(
        `${getEdgeFunctionUrl('public-payment-data')}?type=cost-positions&department_id=${departmentId}`,
        {
          headers: {
            'apikey': getAnonKey(),
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        throw new Error('Failed to fetch cost positions');
      }

      const result = await response.json();
      return result.cost_positions as PublicCostPosition[];
    },
    enabled: !!departmentId,
  });
};
